import {Flex,SkeletonCircle,SkeletonText,TableContainer,Table,Thead, Icon,
  Tbody,Th,Tr,Td, Box,Alert, AlertTitle, AlertDescription, AlertIcon,  
  Text, Input, InputLeftElement, InputGroup,  Spacer,  ButtonGroup, Button, Tooltip
  } from '@chakra-ui/react';
import {SearchIcon} from '@chakra-ui/icons';

import {MdCheckBox,MdCheckBoxOutlineBlank} from "react-icons/md";
import { useState, useEffect, useRef } from 'react';

import { getGovedaNaFarmi,  getGovedaBeforeOmigracijaId } from '../../util/apiGovedo';
import GruntPager from '../custom/GruntPager';

function GovedaList({knjiga_id,_disableboksidgoveda=0,naslov,onSubmitSelected,onClose,preselectedgoveda=[],omigracijaid=0,size='xs',rowsperpage=15,onSelectGovedo,onRemoveGovedo,showButtonSpremi=true, showButtonOdustani=true}) {
    const [state,setState]=useState({goveda:[],errmsg:"", filter:""})
    const [prikaz, setPrikaz] = useState({rowsperpage:rowsperpage,currpage:1,numOfRowsToShow:0,selectallgoveda:false,numberofselected:0})
    const [dataisloading, setDataisloading] = useState(true);
    const srchGrloRef=useRef(null);
    
    

    useEffect(() => {
      const fetchData=async()=>{
        try {
          setDataisloading(true);
          let _numselected=0;
          let res;
          
          
          if (omigracijaid>0) {
              res=await getGovedaBeforeOmigracijaId({knjigaid:knjiga_id,omigracijaid:omigracijaid});
              alert(omigracijaid);
          } else {
            //if (knjiga_id>0) {
              res=await getGovedaNaFarmi({knjigaid:knjiga_id});
            //}
              
          }
          if (res.status===200) {
            let _gov=res.res;
            
            let _i=0;
            while (_i<_gov.length) {
              _gov[_i].selected=false;
              if (preselectedgoveda.includes(_gov[_i].govedo_id)) {
                _gov[_i].selected=true;
                _numselected++;
              }
              
              _gov[_i].filtered=true;
              _i++;
            }
            _gov.sort(govsort);
            setState({...state,goveda:_gov,pages:Math.floor(_gov.length/state.rowsperpage)});
            setPrikaz({...prikaz,numOfRowsToShow:_gov.length,numberofselected:_numselected});
          } else {
            throw new Error(res.message);
          }
  
        } catch (error) {
          setState({...state,errmsg:error.message});
        } finally {
          setDataisloading(false);
        }
      }
      
      fetchData();
    }, [knjiga_id])
   
    useEffect(() => {
      //alert('test');
      const _g=[...state.goveda];
      const _s=_g.filter((item)=>item.selected===true);
      for (const _gov of _s) {
        const _idx=preselectedgoveda.findIndex((item)=>item===_gov.govedo_id);
        if (_idx===-1) {
          const _idx2=_g.findIndex((item)=>item.govedo_id===_gov.govedo_id);
          if (_idx2!==-1) {
            _g[_idx2].selected=false;
          }
        }
      }
      //_g.sort(govsort);
      setState({...state,goveda:_g});
    }, [preselectedgoveda.length])
    

    const SetFilter=(e)=>{
        //const _val=e.target.value;
        let _ar=state.goveda;
       
        const _val0=e.target.value.toUpperCase();
        const _val=_val0.replaceAll("_",".").replaceAll("*",".*");

        const _rgxstr="^.*" + _val+"$"; 
        const _r=new RegExp(_rgxstr);
        let _test=false;
        let _i=0;
        _ar.forEach((gov)=>{
          _test=_r.test(gov.zivbr) || _val0==="";
          gov.filtered=_test;
          if (_test) {
            _i++;
          }

        })
        
        

        setState({...state,goveda:_ar,filter:_val0});
        setPrikaz({...prikaz,numOfRowsToShow:_i,currpage:1});
        
    }
   
    const govsort=(a,b)=>{
      if (a.selected===b.selected) {
        return a.putnica_oznaka>b.putnica_oznaka?1:-1;
      } else {
        if (a.selected && !b.selected) {
            return -1
        } else {
          return 1;
        }
      }
    }

    const ShowError=()=>{
      if (state.errmsg!=="") {
          return (
              <Alert status='error'>
                  <AlertIcon />
                  <AlertTitle>Greška kod dohvata podataka</AlertTitle>
                  <AlertDescription>{state.errmsg}</AlertDescription>
              </Alert>
          )
      }
  }

const selectGovedo=(govedoid)=>{
  const _idx=state.goveda.findIndex((x)=>x.govedo_id===govedoid);
  if (_idx!==-1) {
    let _step=1;
    let _ar=state.goveda;

    if (_ar[_idx].selected===true) {
      _step=-1;
    }
    _ar[_idx].selected=!_ar[_idx].selected;
    setState({...state,goveda:_ar});
    if (_ar[_idx].selected) {
        if (onSelectGovedo!==undefined) {
          onSelectGovedo(_ar[_idx]);  
        }
        
    } else {
      if (onRemoveGovedo!==undefined) {
        onRemoveGovedo(_ar[_idx]);
      }
        
    }
    setPrikaz({...prikaz,numberofselected:(prikaz.numberofselected+_step)})
  }
}



const submitSelected=()=>{
  const _ar=state.goveda.filter((gov)=>{return gov.selected===true});
  onSubmitSelected(_ar);
}

  const ShowGovedaList=()=>{
    let _ar=state.goveda.filter((gov)=>{
      return gov.filtered===true;
    })
    return(
        <TableContainer>
        <Table size={'xs'}>
            <Thead _hover={{cursor:'pointer'}}>
                <Tr>
                    {/* <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}>                    </Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni broj</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum dolaska</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Boks</Th>
                    <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopRightRadius={'sm'}>Oznaka</Th> */}
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>                    </Th>
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni broj</Th>
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum dolaska</Th>
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Boks</Th>
                    <Th borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Oznaka</Th>
                </Tr>
            </Thead>
        <Tbody>
            {_ar.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,index)=>{
                  
                    return (
                        <Tr  key={item.govedo_id}  bg={'white'} fontWeight={'normal'} color={_disableboksidgoveda===item.boks_id?'red':'grunt2.700'}
                                _hover={{bg:'gray.100',cursor:'pointer'}} onClick={()=>handleClick(item)} h={'2rem'} 
                                fontStyle={_disableboksidgoveda===item.boks_id?'italic':'normal'}>
                                    <Td fontSize={size} textAlign={'center'}>
                                      {_disableboksidgoveda===item.boks_id?null:
                                      item.selected?<Icon as={MdCheckBox}  boxSize={5}/>:<Icon as={MdCheckBoxOutlineBlank} boxSize={5}/>}
                                    </Td>
                                    <Td fontSize={size} textAlign={'center'}>
                                      <Tooltip isDisabled={_disableboksidgoveda!==item.boks_id} label={`Govedo se već nalazi u boksu ${item.boks_naziv}`} placement="right-start"> 
                                        {item.zivbr}
                                      </Tooltip>
                                    </Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.spol}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.pasmina_naziv}</Td>
                                    <Td fontSize={size} textAlign={'center'}>{new Date(item.datum_dolazak).toLocaleDateString('hr-HR')}</Td>
                                    <Td fontSize={size} textAlign={'center'}>
                                      <Tooltip label={item.boks_naziv} placement='left-start'>
                                        {item.boks}
                                      </Tooltip>
                                    </Td>
                                    <Td fontSize={size} textAlign={'center'}>{item.putnica_oznaka}</Td>
                                </Tr>
                    )    
                
                
            })}
        </Tbody>
        </Table>
        </TableContainer>
    )
}
//srchGrloRef.current.focus();
const handleClick=(item)=>{
  
  if (item.boks_id!==_disableboksidgoveda) {
    selectGovedo(item.govedo_id);
    srchGrloRef.current.focus();
    srchGrloRef.current.select();  
  }
  
}

const showBrOdabranih=()=>{
  return (
    <Text fontSize={'xs'}>Odabrano {prikaz.numberofselected} od {state.goveda.length}</Text>
  
  
  )
}

const showGoveda=()=>{
  if (dataisloading) {
    return (
      <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
          <SkeletonCircle size='10' />
          <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
      </Box>
    )
  } else {
    return (
      <Box display={'flex'} flexDir={'column'} flex={1}>
            <Flex direction={'row'} bg={'grunt2.700'} color={'white'} rounded={'sm'}>
                <Text fontSize={'sm'} ml={'0.5rem'} fontWeight={'semibold'}>{naslov}</Text>
            </Flex>
            <Flex direction={'row'} alignItems={'center'}>
              <InputGroup size={size} m={'0.5rem'} w={'20rem'} alignContent={'center'}>
                  <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                  <Input focusBorderColor='grunt2.400' ref={srchGrloRef} value={state.filter} variant={'outline'} placeholder={'* (više znakova), _ (jedan znak)'} w={'20rem'} onChange={SetFilter}></Input>
              </InputGroup>
              <Spacer/>
              <ButtonGroup>
                {showButtonSpremi?<Button size={size} colorScheme='grunt2' variant={'solid'} onClick={submitSelected}>Spremi</Button>:null}
                {showButtonOdustani?<Button size={size} colorScheme='grunt2' variant={'outline'} onClick={onClose}>Odustani</Button>:null}
                
              </ButtonGroup>
            </Flex>
            {ShowError()} 
             {ShowGovedaList()} 
            {showBrOdabranih()}
            <Spacer/>
            <Box>
              
              <GruntPager currpage={prikaz.currpage} rowcount={prikaz.numOfRowsToShow} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
              
            </Box>
            
      </Box>
    )
  }
}
  return (
  
    
    <Box flexDirection={'column'} display={'flex'} flex={1} fontSize={'sm'} overflow={'auto'} h={'100%'}>
         {showGoveda()}
    </Box>
    
  )
}

export default GovedaList